import { Directive, effect } from '@angular/core';
import { FormControl } from '@angular/forms';
import { AvoidCopyAndPasteActions } from '../../directives/avoid-copy-paste/avoid-copy-paste';
import { BaseInput } from './base-input';
export const getAvoidActionsForDisabledControls = (formControl: FormControl) => {
  return formControl.disabled ? [AvoidCopyAndPasteActions.paste, AvoidCopyAndPasteActions.cut] : [];
};
/**
 * Class used to add properties and methods that are shared for text inputs
 */
@Directive()
export class TextInput extends BaseInput {
  public avoidCopyandPasteActions = [];
  constructor() {
    super();
    effect(() => {
      this.disabledInput(); // track disabled changes
      this.currentValueInput(); // track currentValue changes (affects fc disabled state)
      if (this.fc) {
        this.avoidCopyandPasteActions = getAvoidActionsForDisabledControls(this.fc);
      }
    });
  }
  /**
   * fc control is created in initFormControl method which is invoked
   * in super class InputBase by calling initFormControl
   */
  ngOnInit(): void {
    super.ngOnInit();
    this.avoidCopyandPasteActions = getAvoidActionsForDisabledControls(this.fc);
  }
}
